interface RateLimiter {
  isAllowed: () => boolean;
  reset: () => void;
}

/**
 * Cria um rate limiter client-side.
 * @param {number} maxCalls - Número máximo de chamadas permitidas na janela
 * @param {number} windowMs - Tamanho da janela em milissegundos
 * @returns {{ isAllowed: () => boolean, reset: () => void }}
 */
export function createRateLimiter(maxCalls: number, windowMs: number): RateLimiter {
  const calls: number[] = [];

  return {
    isAllowed(): boolean {
      const now = Date.now();
      // Remover entradas expiradas
      while (calls.length > 0 && calls[0] < now - windowMs) {
        calls.shift();
      }
      if (calls.length >= maxCalls) {
        return false;
      }
      calls.push(now);
      return true;
    },
    reset(): void {
      calls.length = 0;
    }
  };
}
